import { createAction, props } from "@ngrx/store";
import { CashieringDateResponse } from "../models/cashieringDate/CashieringDateResponse";
import { ServiceError } from "../models/shared/ServiceError";

export const loadWithdrawalDate = createAction(
    '[AchForm-transaction-details - CashieringDate API Call] Load Withdrawal Date',
    props<{ completionDate: string }>()
);

export const loadWithdrawalDateSuccess = createAction(
    '[AchForm-transaction-details - CashieringDate API Call] Load Withdrawal Date Successfully',
    props<CashieringDateResponse>()
)

export const loadWithdrawalDateFailure = createAction(
    '[AchForm-transaction-details - CashieringDate API Call] Withdrawal Date NOT Loaded',
    props<ServiceError>()
)